const initialState = {
    isUserLogged: false,
    activeUser: {
        "email": "developer@fitideas.co",
        "date_joined": "1990-03-18T20:48:49.603124-05:00",
        "authToken":"b70f8c628c4203f052fa689780edd54822ce5e5c",
        "is_active": true,
        "is_admin": true,
        "is_staff": true,
    },

    loginWaitTime: 0,
    enableAuditRegistering: true,
}

const reducer = (state = initialState, action) => {

    if (action.type === 'changeActiveUser') {
        return {
            ...state,
            activeUser: action.newActiveUser,
            isUserLogged: action.isUserLogged
        }
    }

    if (action.type === 'cleanAuthToken') {
        return {
            ...state,
            activeUser: action.newActiveUser,
            isUserLogged: action.isUserLogged
        }
    }

    return state;
}

export default reducer;